/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminOrderStatusType = {
    OrderStatusCreated: 'created',
    OrderStatusPaid: 'paid',
    OrderStatusCanceled: 'canceled',
    OrderStatusReturned: 'returned'
} as const;
export type AdminOrderStatusType = typeof AdminOrderStatusType[keyof typeof AdminOrderStatusType];


export function instanceOfAdminOrderStatusType(value: any): boolean {
    for (const key in AdminOrderStatusType) {
        if (Object.prototype.hasOwnProperty.call(AdminOrderStatusType, key)) {
            if (AdminOrderStatusType[key as keyof typeof AdminOrderStatusType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminOrderStatusTypeFromJSON(json: any): AdminOrderStatusType {
    return AdminOrderStatusTypeFromJSONTyped(json, false);
}

export function AdminOrderStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminOrderStatusType {
    return json as AdminOrderStatusType;
}

export function AdminOrderStatusTypeToJSON(value?: AdminOrderStatusType | null): any {
    return value as any;
}

export function AdminOrderStatusTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminOrderStatusType {
    return value as AdminOrderStatusType;
}

